import ProductsTableRow from './ProductsTableRow';

export default ProductsTableRow;
